$('#Slider-template--25266724176219__collection_list_MQmGUN').slick({
  dots: true,
  infinite: false,
  speed: 100,
  slidesToShow: 4,  // Pe desktop, afișează 4 slide-uri
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,  // pentru tablete
      settings: {
        slidesToShow: 3, 
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,  // pentru mobil
      settings: {
        slidesToShow: 2,  
        slidesToScroll: 2
      }
    }
  ]
});



$('.custom-collection-list').slick({
  dots: true,
  infinite: false,
  speed: 100,
  slidesToShow: 4,  // Pe desktop, afișează 4 slide-uri
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,  // pentru tablete
      settings: {
        slidesToShow: 3, 
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,  // pentru mobil
      settings: {
        slidesToShow: 2,  
        slidesToScroll: 2
      }
    }
  ]
});

jQuery(document).ready(function($) {
    var items = $('.gallery-wrapper .gallery-item'); 
    var currentIndex = 0; 

    function showCurrentItem() {
        items.css('display', 'none');
        $(items[currentIndex]).css('display', 'block');
        currentIndex = (currentIndex + 1) % items.length;
    }

    function initSlider() {
        if ($(window).width() < 425) {
            showCurrentItem(); 
            setInterval(showCurrentItem, 3000); 
        } else {
            items.css('display', 'block');
        }
    }

    initSlider(); 

    $(window).resize(function() {
        initSlider();
    });
});


document.addEventListener("DOMContentLoaded", function() {
    var language = document.documentElement.lang;

    setTimeout(function() {
        var widgetTitle = document.querySelector('.jdgm-carousel-title');
        var reviewsTextElement = document.querySelector('.jdgm-carousel-number-of-reviews');
        var numberOfReviews = reviewsTextElement.getAttribute('data-number-of-reviews'); 
        
      if (widgetTitle) {
            if (language === 'ro-RO') {
                widgetTitle.textContent = 'Lăsăm clienții să vorbească pentru noi'; 
                reviewsTextElement.innerHTML = 'din ' + numberOfReviews + ' recenzii'; 
            } else {
               reviewsTextElement.innerHTML = 'from ' + numberOfReviews + ' reviews'; 
                widgetTitle.textContent = 'Let the customers speak for us '; 
            }
        }
    }, 1300);  
});

/*============================================================================
  Featured promotions
==============================================================================*/
window.featuredPromotions = {
  init() {
    $('.feature-overlay').hover(function () {
      $(this).find('.feature-details').slideDown('100', function () {
        $(this).addClass('reveal-details');
      });
    }, function () {
      $(this).find('.feature-details').removeClass('reveal-details');
      $(this).find('.feature-details').slideUp('100');
    });
    $('.js-featured-promotions').each(function () {
      const $promos = $(this);
      const animationStyle = $(this).data('promo-animation');
      $promos.waypoint(function () {
        $(this.element).find('.feature-section').addClass(`animated ${animationStyle}`);
      }, {
        offset: '80%'
      });
    });
  }
};


/*============================================================================
  Featured promotions
==============================================================================*/
window.featuredPromotions = {
  init() {
    $('.feature-overlay').hover(function () {
      $(this).find('.feature-details').slideDown('100', function () {
        $(this).addClass('reveal-details');
      });
    }, function () {
      $(this).find('.feature-details').removeClass('reveal-details');
      $(this).find('.feature-details').slideUp('100');
    });
    $('.js-featured-promotions').each(function () {
      const $promos = $(this);
      const animationStyle = $(this).data('promo-animation');
      $promos.waypoint(function () {
        $(this.element).find('.feature-section').addClass(`animated ${animationStyle}`);
      }, {
        offset: '80%'
      });
    });
  }
};






